import { Amplify } from "aws-amplify";
import React from "react";
import ReactDOM from "react-dom/client";
import { createRoot } from "react-dom/client";
import { Application } from "./components/Application";
import { Providers } from "./components/Providers";
import "./i18n/config";
import "./index.css";
import { captureFederationErrorDescription } from "./federationErrorHandler";

import awsExportsDev from "./aws-exports-dev";
import awsExportsProd from "./aws-exports-prod";
import awsExportsTest from "./aws-exports-test";

type AwsExports = typeof awsExportsDev;

const buildAmplifyConfig = (exports: AwsExports) => ({
  Auth: {
    Cognito: {
      userPoolId: exports.aws_user_pools_id,
      userPoolClientId: exports.aws_user_pools_web_client_id,
      loginWith: {
        oauth: {
          domain: exports.oauth.domain,
          scopes: ["email", "profile", "openid", "aws.cognito.signin.user.admin"] as (
            | "email"
            | "profile"
            | "openid"
            | "phone"
            | "aws.cognito.signin.user.admin"
          )[],
          redirectSignIn: [exports.oauth.redirectSignIn],
          redirectSignOut: [exports.oauth.redirectSignOut],
          responseType: exports.oauth.responseType as "code" | "token",
        },
      },
    },
  },
});

const getAmplifyConfig = () => {
  const configFileName = import.meta.env.VITE_AMPLIFY_EXPORTS;
  switch (configFileName) {
    case "aws-exports-dev":
      return buildAmplifyConfig(awsExportsDev);
    case "aws-exports-prod":
      return buildAmplifyConfig(awsExportsProd);
    case "aws-exports-test":
      return buildAmplifyConfig(awsExportsTest);
    default:
      throw new Error(`Invalid config file name: ${configFileName}`);
  }
};

captureFederationErrorDescription();

Amplify.configure(getAmplifyConfig());

if (import.meta.env.VITE_ENVIRONMENT !== "prod") {
  import("@axe-core/react").then((axe) => axe.default(React, ReactDOM, 3000));
}

if (import.meta.env.VITE_ENVIRONMENT === "prod") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <Providers>
    <Application />
  </Providers>,
);
export { checkIfCorrect } from "./utils/Questions";
